// The pickup store a user prefers, set in Account information and used by
// checkout as its default. The profile API has no field for this yet, so it is
// kept per user in localStorage (this browser only).
import { useEffect, useState } from "react";

const API_BASE = "https://xianhefairy.com/LotusFairy_API/api";
const keyFor = (userID) => `preferredStore:${userID || "guest"}`;

export const getPreferredStore = (userID) => localStorage.getItem(keyFor(userID)) || "";

export const setPreferredStore = (userID, storeId) => {
  if (storeId) localStorage.setItem(keyFor(userID), String(storeId));
  else localStorage.removeItem(keyFor(userID));
};

// Pickup stores from StoreAddress/Address, flattened with their country
export function usePickupStores() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/StoreAddress/Address`)
      .then((res) => res.json())
      .then((groups) => {
        if (cancelled || !Array.isArray(groups)) return;
        setStores(
          groups.flatMap((group) =>
            (group.Address || []).map((store) => ({
              ...store,
              Country: store.Country || group.Country,
            })),
          ),
        );
      })
      .catch((err) => console.error("Error fetching pickup stores:", err))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  return { stores, loading };
}

// Short name for a store, e.g. "Singapore · Shaw House"
export const storeLabel = (store) =>
  [store.City || store.Country, store.Contact].filter(Boolean).join(" · ");
